// Pathfinder Unchained Variant Multiclassing — Sorcerer archetype benefit tiers.
const sorcererArchetype = [
	{
		level: 1,
		name: 'Bloodline',
		description:
			'You must select a sorcerer bloodline. You treat your character level as your effective sorcerer level for all bloodline powers.',
	},
	{
		level: 3,
		name: 'Bloodline Power',
		description: "You gain your bloodline's 1st-level bloodline power.",
	},
	{
		level: 7,
		name: 'Improved Bloodline Power',
		description: "You gain your bloodline's 3rd-level bloodline power.",
	},
	{
		level: 11,
		name: 'Blood Feat',
		description: "You gain one of your bloodline's feats or Eschew Materials.",
	},
	{
		level: 15,
		name: 'Greater Bloodline Power',
		description: "You gain your bloodline's 9th-level bloodline power.",
	},
	{
		level: 19,
		name: 'True Bloodline Power',
		description: "You gain your bloodline's 15th-level bloodline power.",
	},
];

export default sorcererArchetype;
